module.exports = __webpack_public_path__ + "media/personas/bg-did-you-know-e1dbe7f4.jpg";